import { ChakraV3, dataAttr } from '@piccolohealth/ui';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { FaIndent, FaOutdent } from 'react-icons/fa';

interface Props {
  editor: Editor;
}

export const IndentSelect = (props: Props) => {
  const { editor } = props;

  const items = [
    {
      icon: FaOutdent,
      title: 'Decrease indent',
      action: () => editor.chain().focus().outdent().run(),
      isActive: () => false,
    },
    {
      icon: FaIndent,
      title: 'Increase indent',
      action: () => editor.chain().focus().indent().run(),
      isActive: () => false,
      isDisabled: () => false,
    },
  ];

  return (
    <ChakraV3.HStack gap={0} rounded='lg' overflow='hidden'>
      {items.map((item) => (
        <ChakraV3.IconButton
          key={item.title}
          aria-label={item.title}
          variant='ghost'
          size='xs'
          rounded='none'
          onClick={item.action}
          {...{ 'data-active': dataAttr(item.isActive()) }}
        >
          <item.icon />
        </ChakraV3.IconButton>
      ))}
    </ChakraV3.HStack>
  );
};
